import { FONT_BASE_FAMILY, breakpoints } from '@inbody/core';
import { TypographyVariantsOptions } from '@mui/material/styles';

export const typographyCustomTheme: TypographyVariantsOptions = {
  fontFamily: FONT_BASE_FAMILY,
  title: {
    fontSize: '2rem', //32px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '2rem', //32px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '2.25rem', //36px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '2.25rem', //36px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '2.5rem', //40px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '2.5rem', //40px
    },
  },
  subtitle1: {
    fontSize: '1.5rem', //24px
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '1.5rem', //24px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '1.625rem', //26px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '1.625rem', //26px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '1.75rem', //28px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '1.75rem', //28px
    },
  },
  subtitle2: {
    fontSize: '1.25rem', //20px
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '1.25rem',
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '1.375rem', //22px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '1.375rem', //22px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '1.5rem', //24px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '1.5rem', //24px
    },
  },
  body1: {
    fontSize: '1rem', //16px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '1rem', //16px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '1rem', //16px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '1.125rem', //18px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '1.125rem', //18px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '1.125rem', //18px
    },
  },
  body2: {
    fontSize: '0.875rem', //14px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '1rem', //16px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '1rem', //16px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '1rem', //16px
    },
  },
  body3: {
    fontSize: '0.75rem', //12px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '0.875rem', //14px
    },
  },
  caption: {
    fontSize: '0.75rem', //12px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '0.875rem', //14px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '0.875rem', //14px
    },
  },

  small: {
    fontSize: '0.625rem', //10px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.02em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '0.625rem', //10px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '0.625rem', //10px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '0.75rem', //12px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '0.75rem', //12px
    },
  },

  subtitle3: {
    fontSize: '1.125rem', // 18px
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    [`@media (min-width:${breakpoints.values?.mobileWide}px)`]: {
      fontSize: '1.125rem', // 18px
    },
    [`@media (min-width:${breakpoints.values?.tablet}px)`]: {
      fontSize: '1.1875rem', // 19px
    },
    [`@media (min-width:${breakpoints.values?.laptop}px)`]: {
      fontSize: '1.1875rem', // 19px
    },
    [`@media (min-width:${breakpoints.values?.desktop}px)`]: {
      fontSize: '1.25rem', // 20px
    },
    [`@media (min-width:${breakpoints.values?.desktopWide}px)`]: {
      fontSize: '1.25rem', // 20px
    },
  },
};
